// React
import { useState } from "react";

// React redux
import { useSelector } from "react-redux";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Custum dialog
import DeleteDialog from "layouts/courses/components/modalDelete";
import ModalEdit from "layouts/courses/components/modalEdit";
import MDBadge from "components/MDBadge";

const columns = [
  { Header: "Libellé", accessor: "wording", align: "center" },
  { Header: "Déscription", accessor: "description", align: "left" },
  { Header: "Catégories", accessor: "tags", align: "left" },
  { Header: "Accès", accessor: "access", align: "center" },
  { Header: "Date de création", accessor: "createdAt", align: "center" },
  { Header: "Dérnier modification", accessor: "updatedAt", align: "center" },
  { Header: "action", accessor: "action", align: "center" },
];

export default function CoursesTableData() {
  const courses = useSelector((state) => state.course.allCourses);
  const [currentCourse, setCurrentCourse] = useState(null);
  const [dialog, setDialog] = useState(null);

  const finished = () => {
    setDialog(null);
    setCurrentCourse(null);
  };

  const rows = courses.map((course) => ({
    wording: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {course.wording}
      </MDTypography>
    ),
    description: (
      <div style={{ maxWidth: 200 }}>
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {course.description}
        </MDTypography>
      </div>
    ),
    tags: (
      <div style={{ maxWidth: 200 }}>
        {course.tags.map((tag) => (
          <MDTypography key={tag} variant="caption" color="text" fontWeight="medium">
            {tag.wording}
          </MDTypography>
        ))}
      </div>
    ),
    access: (
      <MDBox ml={-1}>
        <MDBadge
          badgeContent={course.price > 0 ? "payant" : "gratuit"}
          color={
            // eslint-disable-next-line no-nested-ternary
            course.price > 0 ? "success" : "secondary"
          }
          variant="gradient"
          size="sm"
        />
      </MDBox>
    ),
    createdAt: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {course.createdAt}
      </MDTypography>
    ),
    updatedAt: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {course.updatedAt}
      </MDTypography>
    ),
    action: (
      <MDBox component="div" sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <MDTypography
          mx={1}
          sx={{ cursor: "pointer" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={() => {
            setCurrentCourse(course);
            setDialog("edit");
          }}
        >
          Editer
        </MDTypography>
        <MDTypography
          mx={1}
          sx={{ cursor: "pointer" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={() => {
            setCurrentCourse(course);
            setDialog("remove");
          }}
        >
          Supprimer
        </MDTypography>
      </MDBox>
    ),
  }));

  return (
    <>
      <DataTable
        table={{ columns, rows }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        noEndBorder
      />
      {dialog === "edit" && <ModalEdit course={currentCourse} finished={finished} />}
      {dialog === "remove" && <DeleteDialog courseId={currentCourse.id} finished={finished} />}
    </>
  );
}
